import React from "react";
import classes from "./ProductQuantity.module.css";

const ProductQuantity = (props) => {
  const { setQuantity, quantity } = props;

  return (
    <>
      <div className={classes.quantityup_down}>
        <form>
          <div
            className={`${classes.value_button} `}
            onClick={() => {
              if (quantity > 1) {
                setQuantity(quantity - 1);
              }
            }}
          >
            -
          </div>

          <input
            type="number"
            value={quantity}
            name="quantity"
            className={`${classes.number}`}
            onInput={(event) => {
              event.target.value = event.target.value.replace(/[^0-9]/g, "");
              setQuantity(event.target.value);
            }}
            pattern="[0-9]*"
          />

          <div
            className={`${classes.value_button}`}
            onClick={() => {
              setQuantity(quantity + 1);
            }}
          >
            +
          </div>
        </form>
      </div>
    </>
  );
};

export default ProductQuantity;
